module.exports = __webpack_public_path__ + "img/1.1a6c7fe7.png";